export const selectIsVisible = (state) => state.miscellaneous.isVisible;
export const selectNotificationMessage = (state) => state.miscellaneous.message;
export const selectIsLoading = (state) => state.miscellaneous.isLoading;
export const selectRedirectTo = (state) => state.miscellaneous.redirectTo;
export const selectMessageModal = (state) => state.miscellaneous.messageModal;
